module.exports = __webpack_public_path__ + "files/van-der-mee-valentin.532524809bb5600946f0b1c7d7a93120.pdf";